import { useParams } from 'react-router-dom';
import { useEffect,useState,useRef } from 'react';
import { API_URL } from '../../api-config';
import axios from "axios";
import { FaRegTrashCan } from "react-icons/fa6";
import 'katex/dist/katex.min.css';
import { BlockMath, InlineMath } from 'react-katex';
import Arrow from '../../images/arrow.svg';
 
// function parseStrongText(text) {
//   // Dividimos el texto en líneas basadas en el guión "-" que indica un nuevo elemento de la lista
//   const parts = text.split(/-\s*/); 

//   return parts.map((part, index) => {
//     // Si la parte contiene **, reemplazar con <strong>
//     const strongText = part.split(/(\*\*[^*]+\*\*)/).map((subPart, subIndex) => {
//       if (subPart.startsWith('**') && subPart.endsWith('**')) {
//         return <strong key={subIndex}>{subPart.slice(2, -2)}</strong>;
//       }
//       return subPart;
//     });

//     return (
//       // Creamos un <p> o <li> para cada parte de la lista
//       <p key={index} style={{ marginBottom: '8px' }}>
//         {strongText}
//       </p>
//     );
//   });
// }
function parseText(content) {
  // Expresiones matemáticas en bloque (\[\]), en línea (\(\)) y negritas (**)
  const regex = /\\\[([^[\]]+)\\\]|\\\(([^()]+)\)|\*\*([^*]+)\*\*/g;

  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(content)) !== null) {
    // Añadir el texto entre expresiones/negritas
    if (match.index > lastIndex) {
      parts.push(content.substring(lastIndex, match.index));
    }

    // Añadir expresiones matemáticas de bloque (\[\])
    if (match[1]) {
      parts.push(<BlockMath key={parts.length}>{match[1]}</BlockMath>);
    }

    // Añadir expresiones matemáticas en línea (\(\))
    if (match[2]) {
      parts.push(<InlineMath key={parts.length}>{match[2]}</InlineMath>);
    }

    // Añadir texto en negrita (**)
    if (match[3]) {
      parts.push(<strong key={parts.length}>{match[3]}</strong>);
    }

    // Actualizar el índice de búsqueda
    lastIndex = regex.lastIndex;
  }

  // Añadir el texto restante
  if (lastIndex < content.length) {
    parts.push(content.substring(lastIndex));
  }

  return parts;
}
import "./index.css";
const LoadingDots = () => {
  return (
    <div className="loading-dots">
      <span >.</span>
      <span>.</span>
      <span>.</span>
    </div>
  );
};



const GPT = () => {
  const token = localStorage.getItem("token");
  const divRef = useRef(null);
  const {id} = useParams();
  const [conversationNames,setConversationNames] = useState([]);
  const [agents,setAgents] = useState([]);
  const [messages,setMessages] = useState([]);
  const [selectedAgent,setSelectedAgent] = useState(-1);
  const [waiting,setWaiting] = useState(false);
  const [metadata,setMetadata] = useState({}); 
  const checkConversationStatus = async () => {
    await axios.get(`${API_URL}/trading-api/agent/get_conversation_metadata?conversation_id=${id}`).then((response) => {
      setMetadata(response.data);
      let status = response.data.status;
      if (status !== "processing") {
        setWaiting(false); // Stop checking if the status is no longer "processing"
      }
    }).catch(error => {
      console.error('Error checking conversation status:', error);
    });
  };
  useEffect(() => {
    if (!waiting) {
      const fetchMessages = async () => {
        await axios.get(`${API_URL}/trading-api/agent/get_conversation?conversation_id=${id}`, {
          headers: {
            "accept": "application/json",
          }
        }).then((response) => {
          if (response.data !== null) {
            setMessages(response.data);
          }
        }).catch(error => {
          console.error('Error fetching messages:', error);
        });
      };
  
      fetchMessages();
    }
  }, [waiting]);
  useEffect(() => {
    let interval;
    if (waiting) {
      interval = setInterval(() => {
        checkConversationStatus();
      }, 3000); // Check every 3 seconds
    }

    return () => clearInterval(interval); // Cleanup interval on component unmount or when waiting changes
  }, [waiting]);
    useEffect(() => {
      if (divRef.current) {
        divRef.current.scrollTop = divRef.current.scrollHeight;
      }
    });
  const [newConversation,setNewConversation] = useState(true);
  
  const [text, setText] = useState('');
  const textareaRef = useRef(null);

  const handleInput = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 96)}px`; // 96px es equivalente a h-24
    }
  };
  

  const handleSelectAgent = (e) => {
    setSelectedAgent(e.target.value)
  }
  const getData = async () => {

    await axios.get(`${API_URL}/trading-api/agent/my_conversations`,{headers:{
      "accept":"application/json",
        "Authorization":"Bearer "+token,
      }}).then((response)=> {
        
    


        setConversationNames(response.data)
        console.log(response.data,id)})


        if (id !== "new"){
          setNewConversation(false)
          await axios.get(`${API_URL}/trading-api/agent/get_conversation?conversation_id=${id}`,{headers:{
            "accept":"application/json",
              
            }}).then((response)=> {
              
              if (response.data !== null){
                setMessages(response.data)
              }
              
                
              console.log(response.data,id)})
              await axios.get(`${API_URL}/trading-api/agent/get_conversation_metadata?conversation_id=${id}`).then((response)=> {
                setMetadata(response.data)
                let status = response.data.status
                if(status ==="processing"){
                  setWaiting(true)
                }
              })
                
        
        }
        else {
          
          await axios.get(`${API_URL}/trading-api/agent/available_agents`,{headers:{
            "accept":"application/json",
              "Authorization":"Bearer "+token,
            }}).then((response)=> {
              
              
              setAgents(response.data)
              setSelectedAgent(response.data[0].id)
              console.log(response.data)})
        }


  }
  useEffect(() => {
    getData();
  }, []);
  const handleSendMessage = async () => {
          if (newConversation){
            await axios.post(`${API_URL}/trading-api/agent/new_conversation`,{

              "message":text,
              "agent_id":selectedAgent
            },{headers:{
              "accept":"application/json",
              "Authorization":"Bearer "+token,
            }
          }).then((response)=> {
            console.log(response.data)
              window.location.assign("/gpt/"+response.data.id)
            })
          }

          else {

              // setWaiting(true);
              setText("");

              await axios.post(`${API_URL}/trading-api/agent/tools_message`,{
                "conversation_id":id,
                "message":text
              },{headers:{
                "accept":"application/json",
                "Authorization":"Bearer "+token,
              }
            }).then((response)=> {
              // console.log("Respuesta mensaje",response.data)
              let status = response.data.status
              if(status ==="processing"){
                setWaiting(true)
              }
              // setMessages(response.data)
              // setWaiting(false)
              })
            
          }
  }
  const handleDelete = (conversationId) => {
    // Mostrar ventana de confirmación
    const isConfirmed = window.confirm('¿Estás seguro de que deseas borrar la conversación?');
  
    // Si el usuario confirma
    if (isConfirmed) {
      // Obtener el token desde el almacenamiento local
      
  
      // Configurar los headers para la solicitud DELETE
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      };
  
      // Enviar solicitud DELETE con axios
      axios.delete(`${API_URL}/trading-api/agent/conversation/${conversationId}`, config)
        .then(response => {
          console.log('Conversación borrada:', response.data);
          setConversationNames(response.data);
          window.alert('Conversación borrada exitosamente');
          // Lógica adicional, como actualizar la UI o mostrar un mensaje de éxito
        })
        .catch(error => {
          console.error('Error al borrar la conversación:', error);
          // Lógica de manejo de errores, como mostrar un mensaje de error al usuario
        });
    }
  };

  return (
    
    <div className='w-screen h-screen  py-0 flex flex-row '>
        <div className="h-auto bg-blue w-1/4  flex-col p-4 max-h-full overflow-y-scroll flex py-4 pb-4">
          <h1>Mis conversaciones </h1>
          
          {conversationNames.map((name, index) => (
            <div className="flex flex-row border-2  rounded-md p-2 m-1" key={conversationNames[index].id}>
              <a href={`/gpt/${conversationNames[index].id}`} >
              <h1 className='text-sm'>{conversationNames[index].name}</h1>
              
              </a>
              <FaRegTrashCan 
              onClick={()=>{handleDelete(conversationNames[index].id)}}
              className='ml-6 h-2/3 rounded-full mr-2'/>  
            </div>
          ))}


        </div>
        <div className="h-full w-full flex-col px-1 justify-center" >
          <h1 className="text-white font-bold text-lg p-2"> {metadata.name}</h1>
          <div className="mt-10 h-2/3 px-2 flex flex-col justify-between">
            
             {messages.length > 0?
             
             <div className="px-2  rounded-md  h-auto overflow-y-scroll  max-h-full"
                ref = {divRef}>
                  <h1>{waiting}</h1>
              {messages.map((message, index) => (
                <div key={index} className={`flex flex-row ${message.role !== 'user' ? 'justify-start mr-24' : 'justify-end ml-12'}`}>
                  <div className={`bg-${message.role !== 'user' ? 'trasparent border-2' : 'white text-black'} p-2 m-1  rounded-md`}>
                    <h1
                    className='text-left leading-5'
                    >{parseText(message.content)}</h1>
                  </div>
                </div>
                
              ))}
              {waiting && <div className="spinner bg-trasparent border-2 rounded-md w-1/4 m-1 mb-4  p-2">
                <LoadingDots/> </div>}
              </div>
                :
                <div className='w-2/5 m-2 items-start'>
                  
                  <label htmlFor="db_name" className=" text-white font-bold mb-2 inline-flex items-center">Agentes Disponibles:</label>
                    <select
                      name="type"
                      id="type"
                      value={selectedAgent}
                      onChange={handleSelectAgent}
                      className="bg-[#101523] text-white  text-base ml-6" style={{border: 'none' }}
                      required
                    >
                      {agents.map((agente, index) => (
                        <option key={index} value={agente.id}>{agente.name}</option>
                      ))}
                    </select>
                </div>
            }
            <div className="flex flex-row justify-center items-center gap-3 transition mt-auto"> {/* Añadido mt-auto para empujar hacia abajo */}
              <div className="relative flex justify-center items-center w-full max-w-4xl mt-2">
                <textarea
                  ref={textareaRef}
                  className="mt-0 bg-[#00172b] py-3 px-3 pr-16 rounded-[36px] bg-muted/50 border w-full focus:outline-none h-full" // Se agrega espacio a la derecha
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  onInput={handleInput}
                  type="text"
                  placeholder="Type a message..."
                  style={{ resize: 'none' }} // Desactiva el redimensionamiento manual
                />
                <button
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-white"
                  onClick={() => handleSendMessage()}
                >
                  <img src={Arrow} alt="Arrow Icon" className="w-12" />
                </button>
              </div>
            </div>
          </div>
        </div>



    </div>
  );
};

export default GPT;